import { Component, OnInit, AfterViewInit } from '@angular/core';
import { PAGINA_HOME_USUARIO_INTERNO, PAGINA_MANIFESTO_OPERADOR } from '../../../../../tools/URL';
import { FiltroPesquisaDemandaDTO } from '../../../../../entity/FiltroPesquisaDemandaDTO';
import { ManifestoService } from 'src/app/service/manifesto/manifesto.service';
import { ResultadoFiltroDemandaVO } from 'src/app/entity/ResultadoFiltroDemandaVO';
import { MANIFESTO_ENUM } from 'src/app/tools/Manifestos';
import { ShortcutInput } from 'ng-keyboard-shortcuts';
import { MSG_NENHUM_REGISTRO } from 'src/app/tools/Mensagens';
import { Router } from '@angular/router';
import { CadastroUsuario } from 'src/app/entity/CadastroUsuario';
import { PesquisarUsuarioService } from 'src/app/service/usuario/pesquisar-usuario.service';

@Component({
  selector: 'pesquisa-manifesto-operador',
  templateUrl: './pesquisa-manifesto-operador.component.html',
  styleUrls: ['./pesquisa-manifesto-operador.component.css']
})
export class PesquisaManifestoOperadorComponent implements OnInit, AfterViewInit {

  filtro: FiltroPesquisaDemandaDTO;
  listaManifestos: any[];
  usuarios: Array<CadastroUsuario>;
  resultado: ResultadoFiltroDemandaVO;
  homeOperador =  PAGINA_HOME_USUARIO_INTERNO;
  idManifesto: number;
  dataInicial: string;
  dataFinal: string;
  shortcuts: ShortcutInput[];
  numeroProcessoSEI: string;

  constructor(private manifestoService: ManifestoService,
    private router: Router,
    private pesquisarUsuarioService: PesquisarUsuarioService) {

    this.manifestoService.carregarDados().subscribe(manifestos => {

        this.listaManifestos = manifestos.filter(manifesto => manifesto.numeroOrdem !== '1').sort((a, b) => {

          const aEnumKey = Object.keys(MANIFESTO_ENUM).find(key => MANIFESTO_ENUM[key].id === a.id);
          const bEnumKey = Object.keys(MANIFESTO_ENUM).find(key => MANIFESTO_ENUM[key].id === b.id);

          return MANIFESTO_ENUM[aEnumKey].ordem - MANIFESTO_ENUM[bEnumKey].ordem;

        });
        this.listaManifestos.unshift(MANIFESTO_ENUM.TODOS);

      }
    );
    this.resultado = new ResultadoFiltroDemandaVO();
    this.filtro = new FiltroPesquisaDemandaDTO();
    this.shortcuts = [];
    this.usuarios = [];

  }

  ngOnInit() { }

  ngAfterViewInit(): void {

    this.shortcuts.push(
      {
        key: 'alt + l',
        preventDefault: true,
        command: () => {

          if (this.filtroValido(this.filtro)) {

            this.filtroBotao(this.filtro);

          }

        }
      },
      {
        key: 'alt + z',
        preventDefault: true,
        command: () => this.limparFiltro()
      },
      {
        key: 'alt + c',
        preventDefault: true,
        command: () => this.router.navigate([PAGINA_HOME_USUARIO_INTERNO])
      }
    );

  }

  editarManifesto(manifesto) {

    let tipoManifesto = Object.keys(MANIFESTO_ENUM).find(key => MANIFESTO_ENUM[key].id === this.idManifesto);

    if (this.idManifesto === 0) {

      tipoManifesto = manifesto.tipoManifesto;

    }

    this.router.navigate([PAGINA_MANIFESTO_OPERADOR, tipoManifesto.toLowerCase(), manifesto.id]);

  }

  filtroValido(filtro: FiltroPesquisaDemandaDTO): boolean {

    if (!this.idManifesto && this.idManifesto !== 0) {

      return false;

    }

    if (!filtro.email && !filtro.manifestante && !this.dataInicial && !this.dataFinal) {

      return false;

    }

    if (this.dataInicial && !this.dataFinal) {

      return false;

    }

    if (this.dataFinal && !this.dataInicial) {

      return false;

    }

    return true;

  }

  formatarFiltro(filtro: FiltroPesquisaDemandaDTO) {

    filtro.dataInicial = undefined;
    filtro.dataFinal = undefined;

    filtro.manifesto = Object.keys(MANIFESTO_ENUM).find(key => MANIFESTO_ENUM[key].id === this.idManifesto);

    if (
      filtro.protocoloSigla &&
      filtro.protocoloSigla.length >= 2 &&
      /^[A-Za-z]{2}/.test(filtro.protocoloSigla) &&
      filtro.manifesto === 'TODOS'
    ) {
      filtro.protocolo = Number(filtro.protocoloSigla.slice(2));
    } else if (
      filtro.protocoloSigla &&
      filtro.protocoloSigla.length >= 2 &&
      !/^[A-Za-z]{2}/.test(filtro.protocoloSigla)
    ) {
      filtro.protocolo = Number(filtro.protocoloSigla);
      filtro.protocoloSigla = '';
    }

    if (filtro.manifestante === '') {

      filtro.manifestante = undefined;

    }

    if (filtro.protocolo === null) {

      filtro.protocolo = undefined;

    }

    if (this.dataInicial) {

      filtro.dataInicial = this.dataInicial.slice(0, 10);

    }

    if (this.dataFinal) {

      filtro.dataFinal = this.dataFinal.slice(0, 10);

    }

  }

  buscarUsuario() {

    this.pesquisarUsuarioService.findByName(this.filtro.manifestante)
      .subscribe(usuarios => this.usuarios = usuarios,
      erro => console.log(erro));

  }

  manifestanteDigitado() {

    this.usuarios = [];
    this.filtro.email = null;

  }

  usuarioEscolhido(filtro: FiltroPesquisaDemandaDTO) {

    this.filtro.manifestante = undefined;

  }

  filtroBotao(filtro: FiltroPesquisaDemandaDTO) {

    this.formatarFiltro(filtro);
    this.filtrar(filtro);

  }

  filtrar(filtro: FiltroPesquisaDemandaDTO) {

    this.manifestoService.filtrarDemandas(filtro).subscribe((resultado: ResultadoFiltroDemandaVO) => {

      if (this.idManifesto === MANIFESTO_ENUM.TODOS.id ||
        this.idManifesto === MANIFESTO_ENUM.DENUNCIA.id ||
        this.idManifesto === MANIFESTO_ENUM.LGPD.id) {

        resultado.manifestos.forEach(manifesto => {

          if (manifesto.anonimo == true) {

            manifesto.nome = 'SIGILOSO';
            manifesto.email = 'SIGILOSO';

          }

        });

      }

      this.resultado = resultado;

      if (this.resultado.manifestos.length === 0) {

        alert(MSG_NENHUM_REGISTRO);

      }

    }, err => console.log(err));

  }

  limparFiltro() {

    this.idManifesto = undefined;
    this.filtro = new FiltroPesquisaDemandaDTO();
    this.resultado = new ResultadoFiltroDemandaVO();
    this.dataInicial = undefined;
    this.dataFinal = undefined;
    this.usuarios = [];
    this.numeroProcessoSEI = undefined;

    document.getElementById('manifestante').focus();

  }

  setPreviousPage(filtro: FiltroPesquisaDemandaDTO) {

    if (filtro.page > 0) {

      filtro.page--;
      this.filtrar(filtro);

    }

  }

  setNextPage(filtro: FiltroPesquisaDemandaDTO) {

    if (filtro.page < this.resultado.totalPaginas - 1) {

      filtro.page++;
      this.filtrar(filtro);

    }

  }

  setPage(filtro: FiltroPesquisaDemandaDTO, pagina: number) {

    if (filtro.page !== pagina) {

      filtro.page = pagina;
      this.filtrar(filtro);

    }

  }

  setFirstPage(filtro: FiltroPesquisaDemandaDTO) {

    this.setPage(filtro, 0);

  }

  setLastPage(filtro: FiltroPesquisaDemandaDTO) {

    this.setPage(filtro, this.resultado.totalPaginas - 1);

  }

  validarProcessoSEI(event) {
    this.numeroProcessoSEI = ("0000000000000000000000000" + event.target.value).slice(-25) //   0099380-90.2022.8.13.0000
    if (this.numeroProcessoSEI === "0000000000000000000000000"){
      this.numeroProcessoSEI = undefined;
      this.filtro.numeroProcessoSEI = this.numeroProcessoSEI;
    }else{
      this.filtro.numeroProcessoSEI = this.numeroProcessoSEI;
    }


  }




}
